import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  emptyGrid,
  makeNextPeriodRow,
  PriceListFormModel,
  PriceListGridKey,
  PriceListModel,
  PricingGrid,
} from '../../models/price-list-form-slice.model'

const initialState: PriceListFormModel = {
  id: '',
  name: '',
  pricing: emptyGrid(),
  loading: false,
}

const priceListFormSlice = createSlice({
  name: 'priceListForm',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    changeName(state, action: PayloadAction<string>) {
      state.name = action.payload
    },
    setCell(
      state,
      action: PayloadAction<{ grid: PriceListGridKey; row: number; col: number; value: string }>
    ) {
      const { grid, row, col, value } = action.payload
      state[grid].content[row][col] = value
    },
    addRow(state, action: PayloadAction<{ grid: PriceListGridKey }>) {
      const { grid } = action.payload
      state[grid].content.push(makeNextPeriodRow(state[grid]))
    },
    removeRow(state, action: PayloadAction<{ grid: PriceListGridKey; row: number }>) {
      const { grid, row } = action.payload
      state[grid].content.splice(row, 1)
    },
    setGrid(state, action: PayloadAction<{ pricing: PricingGrid }>) {
      state.pricing = action.payload.pricing
    },
    setPriceListForm(state, action: PayloadAction<PriceListModel>) {
      state.id = action.payload.id ?? ''
      state.name = action.payload.name
      state.pricing = action.payload.pricing ?? emptyGrid()
    },
    resetPriceListForm(state) {
      state.id = initialState.id
      state.name = initialState.name
      state.pricing = emptyGrid()
    },
  },
})

export const priceListFormActions = priceListFormSlice.actions

export default priceListFormSlice
